export default __webpack_public_path__ + "static/sidelongHesitance-098d6a0fbfffd6add7fe5f6ed12aeac5.svg";